import {
    MdAccountCircle,
    MdAdd,
    MdAddReaction,
    MdAutorenew,
    MdCancel,
    MdChecklistRtl,
    MdClose,
    MdContentCopy,
    MdDelete,
    MdDisplaySettings,
    MdDownload,
    MdEdit,
    MdExitToApp,
    MdGroupAdd,
    MdHistory,
    MdInfoOutline,
    MdKeyboardArrowDown,
    MdLibraryAddCheck,
    MdLockClock,
    MdNearbyError,
    MdOutlineAddTask,
    MdOutlineAssignmentReturn,
    MdOutlineFolder,
    MdOutlineHelpOutline,
    MdOutlineSend,
    MdOutlineSwapHoriz,
    MdPerson,
    MdPlayArrow,
    MdPlaylistAdd,
    MdPlumbing,
    MdPrint,
    MdRemoveRedEye,
    MdReplay,
    MdSave,
    MdSearch,
    MdSettingsSuggest,
    MdTranslate,
    MdUpload,
    MdManageAccounts, MdCheckCircleOutline, MdApproval, MdClear,
    MdAssignment, MdCalendarMonth, MdDescription,
} from 'react-icons/md'
import {
    BsArchive,
    BsChevronDoubleLeft,
    BsChevronDoubleRight,
    BsChevronLeft,
    BsChevronRight, BsFlag,
} from 'react-icons/bs'
import {FaRoad, FaTools, FaBalanceScaleRight} from 'react-icons/fa'
import {PiGearSixFill, PiMicrosoftExcelLogoBold} from 'react-icons/pi'
import {
    RiProgress5Line,
    RiUserForbidLine,
    RiUserSharedLine,
    RiExternalLinkLine,
    RiEdit2Fill,
    RiCheckboxMultipleFill,
    RiLockUnlockLine, RiLockLine
} from 'react-icons/ri'
import {TbListDetails, TbTargetArrow, TbReportAnalytics,TbDatabaseSmile} from 'react-icons/tb'
import {IoBarChartSharp} from 'react-icons/io5'
import {GrTableAdd} from 'react-icons/gr'

export const Icons = {
    edit: MdEdit, // edycja rekordu
    editExtra: RiEdit2Fill, // edycja rekordu
    delete: MdDelete, // usuwanie rekordu
    wycofaj: MdReplay, // wycofywanie rekordu
    cancel: MdCancel, // anulowanie, np. zdarzenia
    download: MdDownload, // pobieranie pliku
    eye: MdRemoveRedEye, // podgląd rekordu
    add: MdAdd, // dodawanie rekordu
    upload: MdUpload, // wysyłanie pliku
    history: MdHistory, // podgląd historii
    close: MdClose, // zamknięcie okna modalnego, formularza itp, rezygnacja, wyczyszczenie
    playList: MdPlaylistAdd, // rozpoczynanie słownikowej listy
    dropdown: MdKeyboardArrowDown, // rozwijanie listy
    doubleLeft: BsChevronDoubleLeft, // przewijanie do pierwszej strony
    doubleRight: BsChevronDoubleRight, // przewijanie do ostatniej strony
    left: BsChevronLeft, // przewijanie do poprzedniej strony
    right: BsChevronRight, // przewijanie do następnej strony
    exit: MdExitToApp, // wylogowanie
    search: MdSearch, // wyszukiwanie
    road: FaRoad, // droga - hero card dla RoR
    translate: MdTranslate, // słownik - hero card dla słowników
    user: MdAccountCircle, // użytkownik - hero card dla moje konto
    cogs: PiGearSixFill, // ustawienia - hero card dla ustawienia,
    proces: MdSettingsSuggest, // proces - ikona dla procesu
    config: MdPlumbing, // konfiguracja - hero card dla konfiguracji
    excel: PiMicrosoftExcelLogoBold, // excel - ikona dla plików excel
    info: MdInfoOutline, // karta informacyjna itp
    copy: MdContentCopy, // kopiowanie do schowka, kopiuj, klonuj
    person: MdPerson, // osoba, pracownik, operator
    update: MdAutorenew, // aktualizacja, odświeżenie
    error: MdNearbyError, // błąd, problem, niepowodzenie
    send: MdOutlineSend, // złożenie,wysyłanie, wysłane
    swap: MdOutlineSwapHoriz, // zamiana
    task: MdOutlineAddTask, // projekt
    folder: MdOutlineFolder, // folder
    checkList: MdChecklistRtl, // lista kontrolna
    tool: FaTools, // narzędzia
    view: MdDisplaySettings, // widok, zmień widok
    addUser: MdGroupAdd, // dodaj użytkownika
    done: MdLibraryAddCheck, // zakończono
    pending: MdLockClock, // oczekujące
    progres: RiProgress5Line, // w trakcie
    choose: TbTargetArrow, // wybierz
    start: MdPlayArrow, // rozpocznij
    save: MdSave, // zapisz
    details: TbListDetails, // szczegóły
    charts: IoBarChartSharp, // wykresy
    print: MdPrint, // drukowanie
    forbidden: RiUserForbidLine, // brak dostępu
    scale: FaBalanceScaleRight, // waga
    table: GrTableAdd, // zarządzanie wyglądem tabeli
    link: RiExternalLinkLine, // external link
    help: MdOutlineHelpOutline, // pomoc
    autoassigned: MdAddReaction, // samoprzypisanie
    assigned: MdOutlineAssignmentReturn, // przypisanie
    raport: TbReportAnalytics, // raport. raport dzienny
    addToGroup: MdManageAccounts, // dododanie do grupy
    multiselect: RiCheckboxMultipleFill, // wielokrotny wybór
    unlock: RiLockUnlockLine, // odblokuj
    lock: RiLockLine, // zablokuj
    zlozony: MdCheckCircleOutline, // złożony, zakończony sukcesem
    przyjety: MdApproval ,
    zakonczony: BsFlag, // zakończony sukcesem
    clear: MdClear, // czyszczenie pola MultiSelect
    aiDb: TbDatabaseSmile, // text to sql
    project: MdAssignment, // projekt
    calendar: MdCalendarMonth, // kalendarz, harmonogram
    report: MdDescription, // sprawozdanie, raport
    dotsVertical: MdDisplaySettings, // menu akcji (dropdown)
    archive: BsArchive, // archiwum
    reassign: RiUserSharedLine, // przepnij projekt
}
